import React, { PropTypes } from 'react';

const ProfileIcon = ({ size, fillColor }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${size} ${size}`}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0H20V20H0z" />
      <path
        fill={fillColor}
        d="M13.851 11.79c2.805 0 5.087 2.282 5.087 5.087v1.98c-.004.624-.507 1.127-1.13 1.127-.625 0-1.128-.503-1.128-1.127v-1.98c0-1.561-1.271-2.833-2.833-2.833H5.936c-1.561 0-2.833 1.272-2.833 2.833v1.98c0 .624-.503 1.127-1.127 1.127S.85 19.48.85 18.857v-1.98c0-2.805 2.282-5.086 5.087-5.086h7.915zM9.891 0c2.806 0 5.087 2.282 5.087 5.087 0 2.804-2.281 5.082-5.086 5.082S4.805 7.887 4.805 5.082C4.805 2.278 7.087 0 9.892 0zm.084 2.254c-1.607 0-2.916 1.309-2.916 2.916 0 1.608 1.309 2.917 2.916 2.917 1.608 0 2.917-1.31 2.917-2.917 0-1.607-1.31-2.916-2.917-2.916z"
      />
    </g>
  </svg>
);

ProfileIcon.propTypes = {
  fillColor: PropTypes.string,
  size: PropTypes.number
};

ProfileIcon.defaultProps = {
  fillColor: '#000',
  size: 24
};
export default ProfileIcon;



// WEBPACK FOOTER //
// ./src/components/common/Profile/ProfileIcon.js